import { Injectable } from '@angular/core';
import { Headers, RequestOptions } from '@angular/http';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';
import { ApiService } from '../api.service';
import { ApiQueryParams } from './api-query-params';
import { LanguageService } from '../language.service';
import { NotificationService } from './notification.service';

@Injectable()
export class NetworkLevelService { // implements IService {

  constructor(
    public languageSvc: LanguageService,
    private translate: TranslateService,
    private apiService: ApiService,
    private notificationService: NotificationService,
  ) {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    this.apiService.init();
  }

  getNetworkLeveConfig(): Observable<any> {
    return this.apiService.client.networkLevels.config.GET()
      .map((res) => {
        return this.apiService.handleResponse(res);
      });
  }

  getNetworkLevel01(query: ApiQueryParams): Observable<any> {
    return this.apiService.client.networkLevels.networklevel01.GET(
      query.fields, query.filter, query.group, query.aggregatedFields,
      query.sort, query.page, query.archivedOnly, query.opts)
      .map((res) => {
        return this.apiService.handleResponse(res);
      });
  }

  getNetworkLevel02(query: ApiQueryParams): Observable<any> {
    return this.apiService.client.networkLevels.networklevel02.GET(
      query.fields, query.filter, query.group, query.aggregatedFields,
      query.sort, query.page, query.archivedOnly, query.opts)
      .map((res) => {
        return this.apiService.handleResponse(res);
      });
  }

  getNetworkLevel03(query: ApiQueryParams): Observable<any> {
    return this.apiService.client.networkLevels.networklevel03.GET(
      query.fields, query.filter, query.group, query.aggregatedFields,
      query.sort, query.page, query.archivedOnly, query.opts)
      .map((res) => {
        return this.apiService.handleResponse(res);
      });
  }

  getNetworkLevel04(query: ApiQueryParams): Observable<any> {
    return this.apiService.client.networkLevels.networklevel04.GET(
      query.fields, query.filter, query.group, query.aggregatedFields,
      query.sort, query.page, query.archivedOnly, query.opts)
      .map((res) => {
        return this.apiService.handleResponse(res);
      });
  }

  getNetworkLevel05(query: ApiQueryParams): Observable<any> {
    return this.apiService.client.networkLevels.networklevel05.GET(
      query.fields, query.filter, query.group, query.aggregatedFields,
      query.sort, query.page, query.archivedOnly, query.opts)
      .map((res) => {
        return this.apiService.handleResponse(res);
      });
  }

  getNetworkLevel06(query: ApiQueryParams): Observable<any> {
    return this.apiService.client.networkLevels.networklevel06.GET(
      query.fields, query.filter, query.group, query.aggregatedFields,
      query.sort, query.page, query.archivedOnly, query.opts)
      .map((res) => {
        return this.apiService.handleResponse(res);
      });
  }

  getNetworkLevel07(query: ApiQueryParams): Observable<any> {
    return this.apiService.client.networkLevels.networklevel07.GET(
      query.fields, query.filter, query.group, query.aggregatedFields,
      query.sort, query.page, query.archivedOnly, query.opts)
      .map((res) => {
        return this.apiService.handleResponse(res);
      });
  }

  getNetworkLevel08(query: ApiQueryParams): Observable<any> {
    return this.apiService.client.networkLevels.networklevel08.GET(
      query.fields, query.filter, query.group, query.aggregatedFields,
      query.sort, query.page, query.archivedOnly, query.opts)
      .map((res) => {
        return this.apiService.handleResponse(res);
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/core/api/network-level.service.ts